"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RetentionTypeJSONModel = void 0;
const lodash_1 = __importDefault(require("lodash"));
const DEFAULT_TYPE = "nDay";
class RetentionTypeJSONModel {
    constructor(serializedState) {
        this.reset = () => {
            this.resetType();
        };
        this.overwriteFromSerializedState = (serializedState) => {
            if (serializedState) {
                this.setType(serializedState.type);
            }
        };
        this.serialize = () => {
            return {
                type: this.type,
            };
        };
        ////////////////////////////////////////////////
        // Type
        ////////////////////////////////////////////////
        this.getType = () => this.type;
        this.setType = (value) => this.type = this.validateType(value);
        this.resetType = () => {
            this.type = DEFAULT_TYPE;
        };
        this.reset();
        this.overwriteFromSerializedState(serializedState);
    }
    ////////////////////////////////////////////////
    // Validation
    ////////////////////////////////////////////////
    /**
     * @param {string} value
     * @return {RetentionTypeType} `nDay` if invalid or passed value
     */
    validateType(value) {
        if (lodash_1.default.isString(value) && !lodash_1.default.isEmpty(value)) {
            switch (value) {
                case "nDay":
                case "nWeek":
                case "nMonth":
                    return value;
            }
        }
        return DEFAULT_TYPE;
    }
}
exports.RetentionTypeJSONModel = RetentionTypeJSONModel;
